import SingleNewsArticle from '@organisms/SingleNewsArticle';
import HeroCarousel from '@organisms/HeroCarousel';
import HeroAthletesCarousel from '@organisms/HeroAthletesCarousel';
import SocialMediaLinks from '@organisms/SocialMediaLinks';
import NextEvent from '@organisms/NextEvent';
import StatsPanel from '@organisms/StatsPanel';
import LifestyleGrid from '@organisms/LifestyleGrid';
import TextBlock from '@organisms/TextBlock';
import DualTextBlockModal from '@organisms/DualTextBlock';
import SinglePageFeature from '@organisms/SinglePageFeature';
import FeaturedAthletes from '@organisms/FeaturedAthletes';
import NewsCarousel from '@organisms/NewsCarousel';
import PastEventResult from '@organisms/PastEventResult';
import LatestNews from '@organisms/LatestNews';
import LatestNewsPanel from '@organisms/LatestNewsPanel';
import UsefulLinks from '@organisms/UsefulLinks';
import LifestylePanel from '@organisms/LifestylePanel';
import PromotionalBanner from '@organisms/PromotionalBanner';
import NewsArticleRow from '@organisms/NewsArticleRow';
import NewsletterSignup from '@organisms/NewsletterSignup';
import BannerImage from '@organisms/BannerImage';
import VideoCarousel from '@organisms/VideoCarousel';
import VideoDisplayPanel from '@organisms/VideoDisplayPanel';
import TimeTable from '@organisms/TimeTable';
import LiveBlog from '@organisms/LiveBlog';
import EventLiveBlog from '@components/organisms/LiveBlog/EventLiveBlog';
import LatestNewsPanelArticles from '@organisms/LatestNewsPanelArticles';
import LargeImageGallery from '@organisms/LargeImageGallery';
import Grid3x2 from '@organisms/Grid3x2';
import FullWidthTextBlock from '@organisms/FullWidthTextBlock';
import InteractiveMapModal from '@organisms/InteractiveMap';
import PreviewImages from '@assets/images/previews';
import LibraryPanel from '@organisms/LibraryPanel';
import FlashInterviewsModule from '@components/organisms/FlashInterviewsModule';
import ScrollNewsPanel from '@components/organisms/ScrollNewsPanel';
import TabbedModule from '@components/organisms/TabbedModule';
import ProfileModule from '@components/organisms/ProfileModule';
import VideoModule from '@components/organisms/VideoLibrary';
import VideoHero from '@components/organisms/VideoHero';
import FAQModule from '@components/organisms/FAQModule';

export const LIVE_BLOG = 'liveBlog';
export const FLASH_INTERVIEWS = 'flashInterviews';
export const EVENT_LIVE_BLOG = 'eventLiveBlog';
export const NEWS_ARTICLE_ROW = 'newsArticleRow';
export const LATEST_NEWS_PANEL_ARTICLES = 'LatestNewsPanelArticles';
export const BANNER_IMAGE = 'bannerImage';
// TODO: in content module itself those are hardcoded. Resolve dependancy cycle issue and reuse
export const TOP_RANKINGS = 'topRankings';
export const WORLD_RECORDS = 'worldRecords';
export const WORLD_LEADING_ATHLETES = 'worldLeadingAthletes';
export const STATS_PANEL = [TOP_RANKINGS, WORLD_RECORDS, WORLD_LEADING_ATHLETES];
export const INTERACTIVE_MAP = 'interactiveMap';
export const LIBRARY = 'MediaFileAssets';
export const SCROLL_NEWS_PANEL = 'scrollNewsPanel';
export const TABBED_MODULE = 'tabbed';
export const PROFILE_MODULE = 'organisationProfiles';
export const VIDEO_LIBRARY = 'insideTrackVideo';
export const VIDEO_HERO = 'heroVideo';
export const DesignType = {
  ULTIMATE: 'Ultimate',
  CLASSIC: 'Classic',
};
const ALL_DESIGN_TYPES = Object.values(DesignType);
const CONTENT_MODULES = [
  {
    label: 'Tabbed Module',
    type: TABBED_MODULE,
    modal: TabbedModule,
    listItem: TabbedModule.Item,
    previewImg: PreviewImages.TabbedModule,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Profiles module',
    type: PROFILE_MODULE,
    modal: ProfileModule,
    listItem: ProfileModule.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Inside Track Video Module',
    type: VIDEO_LIBRARY,
    modal: VideoModule,
    listItem: VideoModule.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Hero Video',
    type: VIDEO_HERO,
    modal: VideoHero,
    listItem: VideoHero.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Scroll News Panel',
    type: SCROLL_NEWS_PANEL,
    modal: ScrollNewsPanel,
    listItem: ScrollNewsPanel.Item,
    supportedDesignTypes: ALL_DESIGN_TYPES,
  },
  {
    label: 'Featured Athletes',
    type: 'featuredAthletes',
    modal: FeaturedAthletes,
    previewImg: PreviewImages.featuredAthletes,
    listItem: FeaturedAthletes.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Hero Carousel',
    type: 'heroCarousel',
    modal: HeroCarousel,
    previewImg: PreviewImages.heroCarousel,
    listItem: HeroCarousel.Item,
    supportedDesignTypes: ALL_DESIGN_TYPES,
  },
  {
    label: 'Hero Athletes Carousel',
    type: 'heroAthletesCarousel',
    modal: HeroAthletesCarousel,
    previewImg: PreviewImages.heroCarousel,
    listItem: HeroAthletesCarousel.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Grid 3x2',
    type: 'grid3x2',
    modal: Grid3x2,
    listItem: Grid3x2.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Large Image Gallery',
    type: 'largeImageGallery',
    modal: LargeImageGallery,
    listItem: LargeImageGallery.Item,
    supportedDesignTypes: ALL_DESIGN_TYPES,
  },
  {
    label: 'Latest News Carousel',
    type: 'latestNewsCarousel',
    modal: LatestNews,
    previewImg: PreviewImages.latestNews,
    listItem: LatestNews.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Latest News Panel',
    type: 'latestNewsPanel',
    modal: LatestNewsPanel,
    previewImg: PreviewImages.latestNewsPanel,
    listItem: LatestNewsPanel.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Latest News Panel',
    type: LATEST_NEWS_PANEL_ARTICLES,
    modal: LatestNewsPanelArticles,
    previewImg: PreviewImages.latestNewsPanel,
    listItem: LatestNewsPanelArticles.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Library',
    type: LIBRARY,
    modal: LibraryPanel,
    listItem: LibraryPanel.Item,
    previewImg: PreviewImages.LibraryPanel,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Lifestyle Grid',
    type: 'lifestyleGrid',
    modal: LifestyleGrid,
    previewImg: PreviewImages.lifestyleGrid,
    listItem: LifestyleGrid.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Live Blog',
    type: LIVE_BLOG,
    modal: LiveBlog,
    previewImg: PreviewImages.liveBlog,
    listItem: LiveBlog.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    listItem: FlashInterviewsModule.Item,
    modal: FlashInterviewsModule,
    label: 'Flash Interviews',
    type: FLASH_INTERVIEWS,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Event Live Blog',
    type: EVENT_LIVE_BLOG,
    modal: EventLiveBlog,
    previewImg: PreviewImages.liveBlog,
    listItem: EventLiveBlog.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Lifestyle Panel',
    type: 'lifestylePanel',
    modal: LifestylePanel,
    previewImg: PreviewImages.lifestylePanel,
    listItem: LifestylePanel.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'News Carousel',
    type: 'newsCarousel',
    modal: NewsCarousel,
    previewImg: PreviewImages.newsCarousel,
    listItem: NewsCarousel.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Past Event Results',
    type: 'pastEventResults',
    modal: PastEventResult,
    previewImg: PreviewImages.pastEventResult,
    listItem: PastEventResult.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Newsletter Sign up',
    type: 'newsletterSignup',
    modal: NewsletterSignup,
    previewImg: PreviewImages.newsletterSignup,
    listItem: NewsletterSignup.Item,
    supportedDesignTypes: ALL_DESIGN_TYPES,
  },
  {
    label: 'Next Event',
    type: 'nextEventBlock',
    modal: NextEvent,
    previewImg: PreviewImages.nextEvent,
    listItem: NextEvent.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Promotional Banner',
    type: 'promotionalBanner',
    modal: PromotionalBanner,
    previewImg: PreviewImages.promotionalBanner,
    listItem: PromotionalBanner.Item,
    supportedDesignTypes: ALL_DESIGN_TYPES,
  },
  {
    label: 'Single News Article',
    type: 'singleNewsArticle',
    modal: SingleNewsArticle,
    previewImg: PreviewImages.singleNewsArticle,
    listItem: SingleNewsArticle.Item,
    supportedDesignTypes: ALL_DESIGN_TYPES,
  },
  {
    label: 'Single Page Feature',
    type: 'singlePageFeature',
    modal: SinglePageFeature,
    previewImg: PreviewImages.singlePageFeature,
    listItem: SinglePageFeature.Item,
    supportedDesignTypes: ALL_DESIGN_TYPES,
  },
  {
    label: 'Social Media Links',
    type: 'socialMediaLinks',
    modal: SocialMediaLinks,
    previewImg: PreviewImages.socialMediaLinks,
    listItem: SocialMediaLinks.Item,
    supportedDesignTypes: ALL_DESIGN_TYPES,
  },
  {
    label: 'Text Block',
    type: 'textBlock',
    modal: TextBlock,
    previewImg: PreviewImages.textBlock,
    listItem: TextBlock.Item,
    supportedDesignTypes: ALL_DESIGN_TYPES,
  },
  {
    label: 'Dual Text Block',
    type: 'dualTextBlock',
    modal: DualTextBlockModal,
    previewImg: PreviewImages.textBlock,
    listItem: DualTextBlockModal.Item,
    supportedDesignTypes: ALL_DESIGN_TYPES,
  },
  {
    label: 'FAQ',
    type: 'faqModule',
    modal: FAQModule,
    listItem: FAQModule.Item,
    supportedDesignTypes: [DesignType.ULTIMATE],
  },
  {
    label: 'Timetable',
    type: 'timeTable',
    modal: TimeTable,
    previewImg: PreviewImages.timeTable,
    listItem: TimeTable.Item,
    supportedDesignTypes: ALL_DESIGN_TYPES,
  },
  {
    label: 'Video Carousel',
    type: 'videoCarousel',
    modal: VideoCarousel,
    previewImg: PreviewImages.videCarousel,
    listItem: VideoCarousel.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Inside Track Tokyo 2020',
    type: 'goggleBox',
    modal: VideoDisplayPanel,
    previewImg: PreviewImages.videCarousel,
    listItem: VideoDisplayPanel.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Useful Links',
    type: 'usefulLinks',
    modal: UsefulLinks,
    previewImg: PreviewImages.usefulLinks,
    listItem: UsefulLinks.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'News Article Row',
    type: NEWS_ARTICLE_ROW,
    modal: NewsArticleRow,
    previewImg: PreviewImages.newsArticleRow,
    listItem: NewsArticleRow.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Promotional Banner',
    type: BANNER_IMAGE,
    modal: BannerImage,
    previewImg: PreviewImages.emailPromotionalBanner,
    listItem: BannerImage.Item,
    supportedDesignTypes: ALL_DESIGN_TYPES,
  },
  {
    label: 'Add Stats',
    type: [STATS_PANEL[0], STATS_PANEL[1], STATS_PANEL[2]],
    modal: StatsPanel,
    previewImg: PreviewImages.statsPanel,
    listItem: StatsPanel.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
  {
    label: 'Full Width Text Block',
    type: 'fullWidthTextBlock',
    modal: FullWidthTextBlock,
    previewImg: PreviewImages.textBlock,
    listItem: FullWidthTextBlock.Item,
    supportedDesignTypes: ALL_DESIGN_TYPES,
  },
  {
    label: 'Interactive map',
    type: INTERACTIVE_MAP,
    modal: InteractiveMapModal,
    previewImg: PreviewImages.singlePageFeature,
    listItem: InteractiveMapModal.Item,
    supportedDesignTypes: [DesignType.CLASSIC],
  },
];

export default CONTENT_MODULES;

export const presets = {
  pages: {
    omit: [NEWS_ARTICLE_ROW, BANNER_IMAGE, LATEST_NEWS_PANEL_ARTICLES],
  },
  articles: {
    pick: [LIVE_BLOG, LATEST_NEWS_PANEL_ARTICLES, INTERACTIVE_MAP, VIDEO_LIBRARY],
  },
  emails: {
    pick: [NEWS_ARTICLE_ROW, BANNER_IMAGE],
  },
};
